import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import AuthSplitLayout from 'layouts/AuthSplitLayout';
import { useTranslation } from 'react-i18next';
import bgImg from 'assets/img/generic/14.jpg';
import Flex from 'components/common/Flex';

const Login = () => {
  const { t } = useTranslation();
  return (
    <AuthSplitLayout bgProps={{ image: bgImg, position: '50% 20%' }}>
      <Flex alignItems="center" justifyContent="between">
        <h3>{t('LOGIN.LOGIN')}</h3>
      </Flex>
      <LoginForm layout="split" hasLabel />
      <p className="mt-3 mb-0 fs--1 text-600">
        <span className="fw-semi-bold">{t('WAITLIST.WANT_TO_JOIN')} </span>
        <Link to="/waitlist">{t('LOGIN.GET_STARTED')}</Link>
      </p>
    </AuthSplitLayout>
  );
};

export default Login;
